<template>
  <div class='lit-list-view'>
    <h4>Список литературы</h4>
    <transition-group name="flip-list">
      <item
        v-for="item in items"
        :key="item.id"
        :content="item.content"
        :label="item.label"
      ></item>
    </transition-group>
  </div>
</template>

<script>
export default {
  components: {
    Item: require('./LitListItemView.vue')
  },
  props: {
    items: Array
  }
}
</script>



// WEBPACK FOOTER //
// LitListView.vue?5f2d8b7a